import React from 'react';
import Uganda_s3 from './uganda_s3';
import Uganda_s3_subjects from './uganda_s3_subjects';
const Uganda_s3phy = () => {
  return (
    <div>
      <Uganda_s3 />
    <Uganda_s3_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>PHYSICS</h1>
      <h3>Physics section</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in Physics learning and assessment </li>
      <li>Cross-cutting isues integrated in Physics learning and assessment </li>
      <li>Values integrated in Agriculture learning and assessment </li>
      </div>
    </div>
  );
}

export default Uganda_s3phy;